
// import React from "react";
import { convertFromRaw, EditorState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import ReactHtmlParser from 'react-html-parser';
// import { Editor } from "react-draft-wysiwyg";
// converts JS object to Draftjs and returns rich HTML



const convertToHtml = label => {
  if(label && label.entityMap==null){
    label.entityMap = {};
  }
  
  let content = "";
  let str = "";
  if(label) {
    content = EditorState.createWithContent(
      convertFromRaw(label)
    );
    str = stateToHTML(content.getCurrentContent());
  }
  str = str.replace(/<p>/g, "")
  str = str.replace(/<\/p>/g, "")
  return ReactHtmlParser(str);
   
};

export default convertToHtml;